import { SELECT_ELEMENT, UNSELECT_ELEMENT, UNSELECT_ALL, SELECT_ELEMENTS, ADD_FILTER, REMOVE_FILTER, RESET_FILTERS, ADD_FILTERS } from "../../../actions"
import { modelService } from '../../../../services/model';

export default function (oldSelectedElements, newFilteredElements, action) {
  switch (action.type) {
    case SELECT_ELEMENT:
      if (action.element.category == null) {
        const elements = modelService.getComponentById(action.element.id).categories.map(cat => {
          return {
            id: action.element.id,
            category: cat,
            filtered: false
          };
        });
        var element;
        var result = oldSelectedElements;
        for (element of elements) {
          result = [...result, element];
        }
        return result;
      } else {
        return [...oldSelectedElements, action.element];
      }
    case SELECT_ELEMENTS:
      const res = [...oldSelectedElements, ...action.elements];
      return res;
    case UNSELECT_ELEMENT:
      if (action.element.category == null) {
        return oldSelectedElements.filter(element => element.id !== action.element.id);
      } else {
        return oldSelectedElements.filter(element => (element.id !== action.element.id) || (element.category !== action.element.category));
      }
    case UNSELECT_ALL:
      return [];
    case ADD_FILTER:
    case ADD_FILTERS:
    case REMOVE_FILTER:
    case RESET_FILTERS:
      return setFilteredProperty(oldSelectedElements, newFilteredElements);
    default:
      return oldSelectedElements;
  }
}

function setFilteredProperty(oldSelectedElements, newFilteredElements) {
  return oldSelectedElements.map(element => {
    if (newFilteredElements.includes(element.id)) {
      element.filtered = true;
      return element;
    } else {
      element.filtered = false;
      return element;
    }
  });
}


// WEBPACK FOOTER //
// ./src/redux/reducers/elements/selection/index.js